import List from './views/list';
import Item from './views/item';
import content from './content';

export default function Usage({ service } : { service: string }): JSX.Element {
    const dataContent = content(service);

    return (
        <List title={dataContent.title} service={service} > 
            <Item items={dataContent.list}/>
        </List>
    );
}